import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ApiResponse } from "../../../classes/api-response";
import { Constants } from "../../../utils/constants";
import { SnackService } from "../../../services/snack.service";
import { merge } from "lodash-es";
import { Researcher } from "../../../model/researcher";
import { ResearcherCertificate } from "../../../model/researcher-certificate";
import { ResearchersCertificatesService } from "../../../services/researchers-certificates.service";
import { UsersService } from "../../../services/users.service";

@Component({
  selector: 'aw-researcher-certificate-form',
  templateUrl: './researcher-certificate-form.component.html',
  styleUrls: ['./researcher-certificate-form.component.scss']
})
export class ResearcherCertificateFormComponent implements OnInit {

  researcherCertificateForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingResearchers = false;
  saving = false;
  generalError?: ApiResponse;
  _certificate = new ResearcherCertificate();
  selectedResearcher?: Researcher;
  isEditing = false;

  entities = Constants.entities;

  researchers: Researcher[] = [];

  constructor(
    private certificateService: ResearchersCertificatesService,
    private usersService: UsersService,
    private snackService: SnackService,
  ) {




    this.researcherCertificateForm = new UntypedFormGroup(
      {

        creationDate: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        endDate: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        researcher: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        cmId: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      }
    );
  }

  @Input() set certificate(value: ResearcherCertificate) {
    this._certificate = merge(new ResearcherCertificate(), value);
    // this.selectedResearcher = value.box;
    this.isEditing = !!this._certificate.id;
    this.researcherCertificateForm.patchValue(this._certificate);
  }

  ngOnInit(): void {
    this.loadingResearchers = true;

    if (!this.isEditing) {
      this.usersService.getAllResearchers().subscribe(researchers => {
        researchers.forEach(researcher => {
          this.researchers.push(researcher);
        });
        this.loadingResearchers = false;
      });
    }
  }

  saveResearcherCertificate(): void {

    this.saving = true;

    const newCertificate = merge(new ResearcherCertificate(), this._certificate, this.researcherCertificateForm.value);

    this.generalError = undefined;

    if (this._certificate.id) {
      this.certificateService.updateResearcherCertificate(newCertificate)
        .subscribe(
          () => {
            this.saving = false;
            this.certificate = newCertificate;
            this.snackService.success('Certificate updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {

      this.certificateService.createResearcherCertificate(newCertificate)
        .subscribe(
          () => {
            this.saving = false;
            this.certificate = newCertificate;
            this.snackService.success('Certificte created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

}
